import { defineNuxtPlugin } from '#app'
import { useVmStore }      from '~/stores/vm'

export default defineNuxtPlugin(nuxtApp => {
  const vm = useVmStore()

  const doPrefetch = async () => {
    try {
      const res = await fetch('/ProductData.json')
      if (!res.ok) throw new Error('Failed to fetch ProductData.json')
      const products = await res.json()
      vm.products = products
    } catch (e) {
      console.error('Failed to prefetch product data:', e)
    }
  }

  nuxtApp.hook('app:mounted', () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(doPrefetch)
    } else {
      setTimeout(doPrefetch, 30)
    }
  })
})